<template>
  <div class="extra-service-management">
    <div class="page-header">
      <h2><span class="breadcrumb-level">服务管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">宠境酒店</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">增项服务管理</span></h2>
      <div class="header-actions">
        <el-input v-model="searchKeyword" placeholder="搜索服务名称..." clearable prefix-icon="Search" style="width:240px" @input="onSearchInput" />
        <el-button type="primary" @click="handleAdd">新增服务</el-button>
      </div>
    </div>

    <el-table :data="services" stripe v-loading="loading">
      <el-table-column label="名称" prop="name" width="120" />
      <el-table-column label="价格" width="100">
        <template #default="{ row }">¥{{ row.price }}</template>
      </el-table-column>
      <el-table-column label="单位" prop="unit" width="80" />
      <el-table-column label="状态" width="70">
        <template #default="{ row }">
          <el-switch v-model="row.status" @change="handleFieldChange(row, 'status')" />
        </template>
      </el-table-column>
      <el-table-column label="排序" width="200">
        <template #default="{ row }">
          <el-input-number v-model="row.sort_order" :min="0" size="small" @change="handleFieldChange(row, 'sort_order')" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template #default="{ row }">
          <el-button size="small" @click="handleEdit(row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />

    <!-- 编辑弹窗 -->
    <el-dialog v-model="dialogVisible" :title="isEdit ? '编辑服务' : '新增服务'" width="500px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input-number v-model="form.price" :precision="2" :min="0" style="width:200px" />
          <span style="margin-left:8px;color:#909399;font-size:12px;">元</span>
        </el-form-item>
        <el-form-item label="单位" prop="unit">
          <el-input v-model="form.unit" placeholder="例如：次、只、份" style="width:200px" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort_order" :min="0" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import * as hotelApi from '../../api/hotel';

const services = ref([]);
const loading = ref(false);
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 });
const searchKeyword = ref('');
const dialogVisible = ref(false);
const isEdit = ref(false);
const formRef = ref(null);

const form = ref({
  name: '', price: 0, unit: '次', sort_order: 0, status: true,
});
const rules = {
  name: [{ required: true, message: '请输入服务名称', trigger: 'blur' }],
  price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
  unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
};

let searchTimer = null;
const onSearchInput = () => {
  if (searchTimer) clearTimeout(searchTimer);
  searchTimer = setTimeout(() => fetchData(), 300);
};

const fetchData = async () => {
  loading.value = true;
  try { const params = { page: pagination.current_page, per_page: pagination.per_page, search: searchKeyword.value || undefined }; const res = await hotelApi.getExtraServices(params); services.value = res.data || []; pagination.current_page = res.pagination?.current_page || 1; pagination.total = res.pagination?.total || 0; }
  catch { ElMessage.error('获取增项服务列表失败'); } finally { loading.value = false; }
};

const handleAdd = () => {
  isEdit.value = false;
  form.value = { name: '', price: 0, unit: '次', sort_order: 0, status: true };
  dialogVisible.value = true;
};

const handleEdit = (row) => {
  isEdit.value = true;
  form.value = { ...row };
  dialogVisible.value = true;
};

const handleFieldChange = (row, field) => {
  hotelApi.updateExtraService(row.id, { [field]: row[field] });
};

const handleSave = async () => {
  const valid = await formRef.value.validate().catch(() => false);
  if (!valid) return;
  try {
    if (isEdit.value) { await hotelApi.updateExtraService(form.value.id, form.value); ElMessage.success('更新成功'); }
    else { await hotelApi.createExtraService(form.value); ElMessage.success('创建成功'); }
    dialogVisible.value = false; await fetchData();
  } catch { ElMessage.error('操作失败'); }
};

const handleDelete = (row) => {
  ElMessageBox.confirm('确定删除？', '提示').then(async () => {
    await hotelApi.deleteExtraService(row.id); ElMessage.success('删除成功'); await fetchData();
  }).catch(() => {});
};

onMounted(fetchData);
</script>

<style scoped>

</style>
